import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { setAuthToken } from '@/lib/tokenStorage';

const LinkedInCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [status, setStatus] = useState('Processing LinkedIn login...');

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      toast.error(decodeURIComponent(error));
      navigate('/login', { replace: true });
      return;
    }

    if (token) {
      // Store token and load user
      setAuthToken(token);
      window.location.href = '/dashboard';
    } else {
      toast.error('LinkedIn login failed - no token received');
      navigate('/login', { replace: true });
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0A1024] to-white flex items-center justify-center p-4">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#0A66C2] mx-auto mb-4" />
        <p className="text-lg font-medium text-slate-100">{status}</p>
      </div>
    </div>
  );
};

export default LinkedInCallback;
